import { useState, useMemo, useRef, useContext, useEffect } from 'react';
import _ from 'underscore';
import { ToastContext } from "../../../context/ToastContext.js";
import services from "../../../services/services.js";
import { Urls } from "../../../services/Urls.js";




export const useGateKeeper = () => {
    const { showError, showSuccess } = useContext(ToastContext);
    const [tabsList, settabsList] = useState([])
    const tagRef = useRef(null);
    const [loader, setLoader] = useState(true)
    const [hoveredRange, setHoveredRange] = useState([])
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [showPopup, setShowPopup] = useState(false)


    useEffect(() => {
        getGatepassRequestStatusInfo()
    }, [])


    const getGatepassRequestStatusInfo = async (data) => {
        setIsFilterApplied(false)
        let start;
        let end;
        let list = []
        try {
            start = hoveredRange[0]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-");
            end = hoveredRange[1]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-");
        } catch (error) {
            start = hoveredRange[0];
            end = hoveredRange[1];
        }
        const payload = {
            from_date: start || "",
            to_date: end || "",
        };

        setLoader(true)
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETGATEPASSREQUESTSTATUSINFO"), payload)
            if (res.body.data) {
                settabsList(_.filter(res?.body?.data?.gatepass_request_data, (item) => item?.user_code));
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error, "Error");
            showError("Error", error?.response?.data?.errorMessage);
        }
    }


    const handleActions = async (key, rowData) => {
        try {
            const payload = {
                "gate_pass_id": rowData?.gate_pass_id,
                "requested_user_code": rowData?.user_code,
                "leave_type_id": rowData?.leave_type_id,
                "leave_reason": rowData?.leave_reason,
                "requested_to": rowData?.requested_to,
                "is_gatepass_in_time": key === "inTime" ? true : false,
                "is_gatepass_out_time": key === "outTime" ? true : false,
                "user_out_datetime": rowData?.user_out_datetime || ""
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTGATEPASSREQUEST"), payload);
            if (res.body.data) {
                setShowPopup({ show: false, data: null, key: "" })
                getGatepassRequestStatusInfo()
                showSuccess('Success', res.body.message)
            } else {
                showError('error', res?.body.errorMessage)
            }
        } catch (error) {
            console.error(error)
        }
    }



    return useMemo(() => ({
        tagRef, loader, tabsList, hoveredRange, setHoveredRange, getGatepassRequestStatusInfo, isFilterApplied, setIsFilterApplied, handleActions, showPopup, setShowPopup
    }), [tagRef, loader, tabsList, hoveredRange, setHoveredRange, getGatepassRequestStatusInfo, isFilterApplied, setIsFilterApplied, handleActions, showPopup, setShowPopup])
}